export enum VIDEO_ACTIONS {
    playbackFailed = 'listings.event_video_playback_failed',
    playbackEnd = 'listings.event_video_playback_end',
}
